import { render } from "./mentalHealthPolicy.vue?vue&type=template&id=089fe909&scoped=true"
import script from "./mentalHealthPolicy.vue?vue&type=script&lang=js"
export * from "./mentalHealthPolicy.vue?vue&type=script&lang=js"

import "./mentalHealthPolicy.vue?vue&type=style&index=0&id=089fe909&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089fe909"]])

export default __exports__